import { call, put, takeLatest } from 'redux-saga/effects';
import { InsuranceClaimApi } from '@apis/InsuranceClaimApi';
import { insuranceClaimQuickUpdate, insuranceClaimQuickUpdateSuccess, insuranceClaimQuickUpdateError, InsuranceClaimQuickUpdatePayload } from './action';
import { SagaPayload } from '@utils/typescript';
import { toastShow } from '@components/ToastProvider';
import i18n from '@components/i18n';

function* handleInsuranceClaimQuickUpdate({ payload }: SagaPayload<InsuranceClaimQuickUpdatePayload>) {
  const { claimableType, claimableId, status, note } = payload;
  try {
    yield call(InsuranceClaimApi.put, {
      claimableType,
      claimableId,
      status,
      note,
    });
    yield put(insuranceClaimQuickUpdateSuccess({ claimableType, claimableId }));
    yield put(toastShow({ status: 'success', body: i18n.t('toast.insuranceClaimUpdate.success') }));
  } catch (e) {
    yield put(insuranceClaimQuickUpdateError({ claimableType, claimableId }));
    yield put(toastShow({ status: 'danger', body: i18n.t('toast.insuranceClaimUpdate.error') }));
  }
}

export default function* () {
  yield takeLatest(insuranceClaimQuickUpdate, handleInsuranceClaimQuickUpdate);
}
